export default "__VITE_ASSET__D73DnGvA__"